<template>
  <div id="buying-zone" class="pdp-product-container">
    <section :class="{'h-screen': loading}">
      <div v-if="!loading">
        <pdp-no-product-data v-if="!productData" @tryAgain="loadProductData" />
        <component
          :is="productDetailsComponent"
          v-else
          :product="productData"
          :options="options"
          :base-properties="baseProperties"
          :copy-positioning-statement="copyPositioningStatement"
        />
      </div>
    </section>
  </div>
</template>

<script>
import PdpNoProductData from '@/components/containers/pdp/PdpNoProductData';
import PdpB2bProductDetails from '@/components/containers/pdp/b2b/PdpProductDetails';
import PdpB2cProductDetails from '@/components/containers/pdp/b2c/PdpProductDetails';
import TrekLoading from '@/components/TrekLoading';
import {mapGetters} from 'vuex';
import {ProductApi} from '@/api/product';
import {filterArchivedProducts} from '@/components/containers/pdp/utils/filter-archived-products';

export default {
  name: 'PdpBuyingZoneContainer',

  components: {PdpNoProductData, TrekLoading},

  props: {
    copyPositioningStatement: {
      type: String,
      default: '',
    },
    productId: {
      type: String,
      required: true,
    },
    options: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      loading: true,
      productData: null,
    };
  },

  computed: {
    ...mapGetters('backend', ['b2b']),
    productDetailsComponent() {
      return this.b2b ? PdpB2bProductDetails : PdpB2cProductDetails;
    },
  },

  mounted() {
    this.loadProductData();
  },

  methods: {
    initializeLegacyPdpHandlers() {
      // This method must be refactored.
      const event = new Event('init-pdp');
      window.dispatchEvent(event);
    },
    loadProductData() {
      this.loading = true;

      ProductApi.loadProduct(this.productId)
        .then((data) => {
          this.productData = filterArchivedProducts(data);
          this.$nextTick(() => {
            this.initializeLegacyPdpHandlers();
            this.loading = false;
          });
          this.$emit('is-archived', this.productData.isArchived);
        })
        .catch((reason) => {
          console.error(reason.message);
          this.loading = false;
          this.productData = null;
        });
    },
  },
};
</script>
